import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';

import {
  FinanceCouncil,
  PrequalificationCouncil,
  SpecializationCouncil,
} from 'features/Council/pages';
import { ReviseProjectProposalDetail } from 'features/ReviseProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';
import TimeLine from 'features/ReviseProjectProposal/components/TimeLine';
import { TEMPLATE } from 'constant';
import { useGetGeneralInfoById } from 'utils/hooks/projectProposals';
import Loading from 'components/Loading';

function ReviseProjectProposalDetailPage() {
  const { t } = useTranslation();
  const { projectProposalId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = location;

  const { data, isLoading } = useGetGeneralInfoById(projectProposalId, {
    enabled: !state?.template,
  });

  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 0;

  useEffect(() => {
    if ([state?.template, data?.template].includes(TEMPLATE[1595]) && tab === '3') {
      navigate('.?tab=2', {
        state: { template: state?.template || data?.template },
      });
    }
  }, [state, data]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          borderRadius: '12px',
          overflowY: 'auto',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TimeLine />

        <div
          style={{
            overflowY: 'auto',
            borderRadius: '12px',
            border: '1px solid var(--surface-border)',
            backgroundColor: 'white',
            flex: 1,
          }}
        >
          <TabView
            activeIndex={parseInt(tab, 10)}
            onTabChange={(e) =>
              navigate(`.?tab=${e.index}`, {
                state: { template: state?.template || data?.template },
              })
            }
          >
            {ability.can('read', 'project_proposal') ? (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab0')}
                leftIcon="pi pi-file mr-2"
              >
                <ReviseProjectProposalDetail />
              </TabPanel>
            ) : (
              <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
            )}

            {ability.can('read_prequalification', 'council') && (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab1')}
                leftIcon="pi pi-list mr-2"
              >
                <PrequalificationCouncil />
              </TabPanel>
            )}
            {ability.can('read', 'council') && (
              <TabPanel
                header={t(
                  `projectProposal.viewDetail.${
                    [state?.template, data?.template].includes(TEMPLATE[1595])
                      ? 'labelTab2Combine'
                      : 'labelTab2'
                  }`
                )}
                leftIcon="pi pi-list mr-2"
              >
                <SpecializationCouncil />
              </TabPanel>
            )}
            {ability.can('read', 'council') &&
              ![state?.template, data?.template].includes(TEMPLATE[1595]) && (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab3')}
                leftIcon="pi pi-list mr-2"
              >
                <FinanceCouncil />
              </TabPanel>
            )}
          </TabView>
          <ScrollTop target="parent" />
        </div>
      </Layout>
    </LayoutProvider>
  );
}

export default ReviseProjectProposalDetailPage;
